import React from 'react'

const Contact = () => {
  return (
    <section id="contact" className="bg-accent py-12 sm:py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-4xl font-bold mb-4 text-textPrimary">
            Get In Touch
          </h2>
          <div className="w-16 sm:w-20 h-1 bg-primary mx-auto mb-4 sm:mb-6"></div>
          <p className="font-body text-base sm:text-lg text-textSecondary max-w-2xl mx-auto px-4">
            I'm currently open to new opportunities and collaborations. Let's build something great together!
          </p>
        </div>

        {/* Contact Content - Mobile First Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-start">
          {/* Contact Information */}
          <div>
            <h3 className="font-heading text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-textPrimary">
              Let's Connect
            </h3>
            <p className="font-body text-base sm:text-lg mb-6 sm:mb-8 text-textSecondary leading-relaxed">
              Whether you have a project in mind, want to discuss opportunities, or just want to say hello, 
              I'd love to hear from you. Feel free to reach out through any of the channels below.
            </p>
            
            {/* Contact Methods - Mobile Optimized */}
            <div className="space-y-4 sm:space-y-6">
              <div className="flex items-center group">
                <div className="bg-primary/10 p-3 rounded-lg mr-4 group-hover:bg-primary/20 transition-colors duration-300 flex-shrink-0">
                  <svg className="w-5 sm:w-6 h-5 sm:h-6 text-primary" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-body text-textSecondary text-sm">Email</p>
                  <a 
                    href="mailto:techstack.developer04@gmail.com" 
                    className="font-body text-primary font-semibold hover:text-primaryBright transition-colors duration-300 text-sm sm:text-base break-all"
                  >
                    techstack.developer04@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-center group">
                <div className="bg-primary/10 p-3 rounded-lg mr-4 group-hover:bg-primary/20 transition-colors duration-300 flex-shrink-0">
                  <svg className="w-5 sm:w-6 h-5 sm:h-6 text-primary" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-body text-textSecondary text-sm">LinkedIn</p>
                  <a 
                    href="https://linkedin.com/in/aaaaarryyan/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="font-body text-primary font-semibold hover:text-primaryBright transition-colors duration-300 text-sm sm:text-base break-all"
                  >
                    linkedin.com/in/aaaaarryyan/
                  </a>
                </div>
              </div>

              <div className="flex items-center group">
                <div className="bg-primary/10 p-3 rounded-lg mr-4 group-hover:bg-primary/20 transition-colors duration-300 flex-shrink-0">
                  <svg className="w-5 sm:w-6 h-5 sm:h-6 text-primary" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-body text-textSecondary text-sm">GitHub</p>
                  <a 
                    href="https://github.com/TheAryan04" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="font-body text-primary font-semibold hover:text-primaryBright transition-colors duration-300 text-sm sm:text-base break-all"
                  >
                    github.com/TheAryan04
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Professional Person GIF - Full Coverage */}
          <div className="rounded-lg overflow-hidden shadow-lg">
            <img 
              src="https://media.giphy.com/media/qgQUggAC3Pfv687qPC/giphy.gif" 
              alt="Professional person working on computer"
              className="w-full h-full object-cover min-h-[400px] sm:min-h-[450px]"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact
